import styled from "@emotion/styled";
import { COLOR_TERTIARY, NAV_Z_INDEX } from "../../../theme";

const Drawer = styled.div`
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background: ${COLOR_TERTIARY};
  display: flex;
  flex-direction: column;
  z-index: ${NAV_Z_INDEX};
  border-radius: 16px;
  gap: 8px;
`;

export default Drawer;
